import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _typeof from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/typeof";

/**
 * Created by commyfeng on 2016/10/19.
 */
import alertComponent from './alertComponent.vue';
import toastComponent from './toastComponent.vue';
import shareComponent from './shareComponent.vue';
import loginComponent from './loginComponent.vue';
import loadingComponent from './loadingComponent.vue';
var DialogPlugin = {};

DialogPlugin.install = function (Vue, option) {
  var installComponent = {
    alertComponent: alertComponent,
    toastComponent: toastComponent,
    shareComponent: shareComponent,
    loginComponent: loginComponent,
    loadingComponent: loadingComponent
  };

  for (var name in installComponent) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    var VueComponent = Vue.extend(installComponent[name]);
    var instance = new VueComponent().$mount(div);
    var func = installComponent[name].install(Vue, instance);

    if (_typeof(func) === 'object') {
      for (var i in func) {
        DialogPlugin[i] = func[i];
      }
    } else if (typeof func === 'function') {
      DialogPlugin[name.replace('Component', '')] = func;
    }
  }
};

export default DialogPlugin;